/* eslint-disable no-else-return */
import * as React from 'react'
import {
  Paper,
  Button,
  ButtonBase,
  Divider,
  Box,
  Typography,
  Tooltip,
  Grid,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import IconPicker from '../../apps/AppComponents/IconPicker/IconPicker'

import styles from './WidgetStyles'
import { logDashboardEvent } from '../events'

/**
 * Reusable Widget Body
 */
// eslint-disable-next-line no-unused-vars
export function Header({ title, category }) {
  const classes = styles()
  if (title === 'My Profile') {
    return null
  }
  // TODO: Add back ability to remove widget from dashboard
  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h1" className={classes.header}>
            {title}
          </Typography>
        </Grid>
      </Grid>
      <Divider classes={{ root: classes.divider }} />
    </>
  )
}

export function Content({
  children,
  className = null,
  showNote,
  noteMessage,
  notePosition,
  noteBackground,
  noteIcon,
  noteUrl,
  noteFontColor,
  addFooterStroke = false,
  noHeader = false,
  widgetId = null,
}) {
  const dispatch = useDispatch()

  const targetRef = React.useRef()
  const [height, setHeight] = React.useState({
    height:
      showNote && notePosition && noteMessage && noteMessage !== '' ? 435 : 478,
  })
  React.useEffect(() => {
    if (
      targetRef.current !== null &&
      showNote &&
      noteMessage &&
      noteMessage !== '' &&
      notePosition
    ) {
      setHeight({
        height: noteMessage ? 471 - targetRef.current.offsetHeight : 478,
      })
    }
  }, [])

  const handleClick = (url, eventName) => {
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardLinkEvent',
        widgetId,
        eventName,
        url,
      )
      window.open(url, '_blank')
    }
  }

  const classes = styles()
  if ((notePosition === 'bottom' || notePosition === 'middle') && showNote) {
    // Note position is bottom or middle
    return (
      <div className={`${classes.content} ${classes.contentNoOverflowY}`}>
        <div
          className={`${className} ${
            addFooterStroke && classes.linkContainerStroke
          }
}`}
        >
          {children}
        </div>
        <div className={classes.linkButtonDiv}>
          <Button
            className={classes.linkButton}
            ref={targetRef}
            style={{ backgroundColor: noteBackground }}
            onClick={() => handleClick(noteUrl, noteMessage)}
          >
            {noteIcon && (
              <IconPicker iconName={noteIcon} size="lg" color={noteFontColor} />
            )}
            <Typography
              style={{
                color: noteFontColor,
              }}
              variant="subtitle1"
            >
              {noteMessage}
            </Typography>
          </Button>
        </div>
      </div>
    )
  } else if (notePosition === 'top' && showNote) {
    // Note position is top
    // TODO: is notePosition ever top?
    return (
      <div className={[classes.content, className].join(' ')}>
        <div className={classes.linkButtonDiv}>
          <Button
            className={classes.linkButton}
            ref={targetRef}
            style={{ backgroundColor: noteBackground }}
            onClick={() => handleClick(noteUrl, noteMessage)}
          >
            {noteIcon && (
              <IconPicker iconName={noteIcon} size="lg" color={noteFontColor} />
            )}
            <Typography
              style={{
                color: noteFontColor,
              }}
              variant="subtitle1"
            >
              {noteMessage}
            </Typography>
          </Button>
        </div>
        <div
          className={[classes.content, className].join(' ')}
          style={{ height: height.height }}
        >
          {children}
        </div>
      </div>
    )
  } else {
    // No notes
    return (
      <div
        className={[classes.content, className].join(' ')}
        style={{ maxHeight: noHeader && 515 }}
      >
        {children}
      </div>
    )
  }
}

// TODO: Double check with Edwin why blurry was removed

export function Spacer() {
  const classes = styles()
  return <div className={classes.spacer} />
}

export function RowContainer({ children, className = null }) {
  const classes = styles()
  return (
    <div className={[classes.rowContainer, className].join(' ')}>
      {children}
    </div>
  )
}

export function Row({ children, className }) {
  const classes = styles()
  return (
    <ButtonBase className={[classes.row, className].join(' ')}>
      {children}
    </ButtonBase>
  )
}

export function TouchableRow({ children, className, onClick }) {
  const classes = styles()
  return (
    <ButtonBase
      className={[classes.row, className].join(' ')}
      onClick={onClick}
    >
      {children}
    </ButtonBase>
  )
}

export function SmallIconLink({
  icon,
  iconLabel,
  classes,
  link,
  widgetId,
  dispatch,
}) {
  const handleEventClick = () => {
    window.open(link, '_blank')
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        iconLabel.props.children,
        link,
      )
    }
  }
  return (
    <ButtonBase
      onClick={() => handleEventClick()}
      className={classes.linkContainer}
    >
      <IconPicker iconName={icon} size="lg" color="white" />
      <Typography className={classes.tinyText}>{iconLabel}</Typography>
    </ButtonBase>
  )
}

export function TabLink({
  icon,
  iconLabel,
  hyperLink,
  disabled = false,
  widgetId,
  dispatch,
}) {
  const classes = styles()
  const [open, setOpen] = React.useState(false)

  const isOverflowing = (e) =>
    e.offsetWidth < e.scrollWidth || e.offsetHeight < e.scrollHeight

  const handleMouseEnter = (event) => {
    if (disabled) {
      return
    }
    const element = event.target
    if (isOverflowing(element)) {
      setOpen(true)
    }
  }

  const handleMouseLeave = () => {
    if (disabled) {
      return
    }
    setOpen(false)
  }

  const handleEventClick = () => {
    window.open(hyperLink, '_blank')
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        iconLabel,
        hyperLink,
      )
    }
  }

  const handlePress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      window.open(hyperLink, '_blank')
    }
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        iconLabel,
        hyperLink,
      )
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexDirection="column"
      className={classes.tabLinkBox}
    >
      <Grid
        container
        tabIndex={0}
        onClick={handleEventClick}
        onKeyPress={handlePress}
        className={classes.profileDeepLink}
      >
        <Grid item xs={12}>
          {icon}
        </Grid>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.textCenter}
          >
            <Tooltip
              title={iconLabel}
              enterDelay={500}
              onOpen={handleMouseEnter}
              onClose={handleMouseLeave}
              enterNextDelay={250}
              open={open}
            >
              <Typography
                variant="body2"
                id="tab-link-label"
                component="p"
                color="textPrimary"
                className={classes.tabLinkText}
              >
                {iconLabel}
              </Typography>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

function Widget({ children, className = null }) {
  const classes = styles()
  return (
    <Paper className={[classes.widget, className].join(' ')} elevation={0}>
      {children}
    </Paper>
  )
}

Widget.Header = Header
Widget.Content = Content
Widget.Row = Row
Widget.TouchableRow = TouchableRow
Widget.RowContainer = RowContainer
Widget.Spacer = Spacer
Widget.TabLink = TabLink
Widget.SmallIconLink = SmallIconLink

export default Widget
